const uiSchema = () => ({
  wolesale_items: {
    'ui:options': {
      copyable: true,
      orderable: false
    },
    items: {
      quantity: {
        'ui:options': {
          adornment: 'عدد',
        },
      },
      discount_percent: {
        'ui:options': {
          adornment: 'درصد',
        },
      },
      discount_amount: {
        'ui:options': {
          adornment: 'تومان',
          convertToWord: true,
        },
      },
    },
  },
});

export default uiSchema;
